import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../../locales/translations';

export function useTexts() {
  const { t } = useTranslation(TranslationsKeys.STUDENT_FILE_TABS);
  return {
    tabTitle: t(`tutors.tabTitle`),
    sectionTitle: t(`tutors.sectionTitle`),
    notAssigned: t(`tutors.notAssigned`),
    noResults: t(`tutors.noResults`),
    table: {
      studyPlan: t(`tutors.table.studyPlan`),
      nameAndId: t(`tutors.table.nameAndId`),
      email: t(`tutors.table.email`),
    },
    toast: {
      success: t(`tutors.toast.success`),
      error: t(`tutors.toast.error`),
    },
  };
}
